import moment from 'moment';
import { formatISODateStr } from 'utils';
import type { BuyerAppointments } from './types';

function sortAppointments(appointments: BuyerAppointments) {
  const sortedAppointments = appointments.sort(
    (a, b) => moment(a.time).unix() - moment(b.time).unix(),
  );
  const sortedDates: string[] = [];
  const groupedAppointmentsByDate: {
    [key: string]: BuyerAppointments;
  } = {};
  sortedAppointments.forEach(appointment => {
    const dateString = formatISODateStr(
      appointment.time,
      appointment.listing.timezone,
    );
    if (!sortedDates.includes(dateString)) {
      sortedDates.push(dateString);
      groupedAppointmentsByDate[dateString] = [appointment];
    } else {
      groupedAppointmentsByDate[dateString].push(appointment);
    }
  });

  return {
    sortedDates,
    groupedAppointmentsByDate,
  };
}

export default sortAppointments;
